import { ref, computed } from "vue";
import { theme } from "#tailwind-config";
import type { CSSProperties } from "vue";

export function useChatStyles() {
  const colorMode = useColorMode();
  const windowHeight = ref(0); // You might need to set this value properly

  const chatStyle = computed<CSSProperties>(() => ({
    backgroundColor: "transparent",
    borderRadius: "0px",
    width: "435px",
    height: `${windowHeight.value * 0.5}px`,
    border: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    zIndex: "1000",
    position: "relative",
    bottom: "-24px",
  }));

  const inputAreaStyle = ref({
    styles: {
      container: {
        display: "flex",
        width: "495px",
        flexDirection: "row",
        textAlign: "left",
        padding: "0px",
        margin: "0px",
        alignItems: "end",
        justifyContent: "center",
        paddingTop: "6px",
      },
    },
  });

  const textInput = computed(() => ({
    styles: {
      text: {
        backgroundColor: "transparent",
        border: "none",
        color: "hsl(var(--primary))",
      },
      container: {
        width: "350px",
        left: "22px",
        border: `1.5px solid`,
        borderColor: "hsl(var(--muted))",
        borderRadius: "100px",
        height: "40px",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: "10px",
        margin: "0px",
        marginBottom: "4px",
        marginRight: "-10px",
        background: "hsl(var(--muted))",
        boxShadow: "none",
      },
    },
    placeholder: { text: "Ask SuperSeeded" },
  }));

  const submitButtonStyles = computed(() => ({
    "submit": {
      "container": {
        
        "hover": {"backgroundColor": "transparent"},
        
      },
      "svg": {
        "content": `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 24 24"><!-- Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE --><g fill="none"><path d="M22 12c0-5.522-4.476-10-10-10C6.479 2 2 6.479 2 12c0 5.524 4.478 10 10 10c5.524 0 10-4.476 10-10zm-14.53.28a.75.75 0 0 1-.073-.976l.073-.084l4-4a.75.75 0 0 1 .977-.073l.085.072l4 4.002a.75.75 0 0 1-.977 1.133l-.084-.073l-2.72-2.721v6.691a.75.75 0 0 1-.649.743l-.102.007a.75.75 0 0 1-.743-.648l-.007-.102v-6.69l-2.72 2.72a.75.75 0 0 1-.976.072l-.084-.072z" fill="currentColor"/></g></svg>`
      }
    }
  }))

  const auxiliaryStyle = computed(
    () => `
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsl(var(--primary));
      border-radius: 5px;
    }

    ::-webkit-scrollbar-track {
      background-color: hsl(var(--background));
      border-radius: 5px;
    }

    #input{
      padding-top: 6px;
    }
    .input-button-svg.inside-right{

      margin-right: -20px;
    }



  `
  );

  const avatars = computed(() => ({
    default: {
      styles: {
        avatar: { height: "30px", width: "30px" },
        container: { marginTop: "8px" },
      },
    },
    ai: {
      src:
        colorMode.value == "dark"
          ? "/images/logos/superseeded_logo_small.png"
          : "/images/logos/superseeded_logo_small.png",
      styles: {
        avatar: {
          marginLeft: "-3px",
          objectFit: "contain"
        }
      },
    },
    user: {
      src: "", // You'll need to set this dynamically
      styles: { avatar: { display: "none", borderRadius: "15px" } },
    },
  }));

  const messageStyles = computed(() => ({
    loading: {
      bubble: {
        backgroundColor: "hsl(var(--muted))",
        fontSize: "10px",
        color: "hsl(var(--primary))",
      },
    },
    error: {
      bubble: {
        backgroundColor: theme.colors.destructive,
      },
    },
    default: {
      ai: {
        bubble: {
          background: "transparent",
          color: "hsl(var(--primary))",
          fontSize: "16px",
          maxWidth: "75%",
        },
      },
      user: {
        bubble: {
          background: "linear-gradient(45deg, hsl(var(--muted)/20), hsl(var(--muted)/20))",
          color: "hsl(var(--primary))",
          fontSize: "16px",
          maxWidth: "75%",
          borderRadius: "30px",
          padding: "10px",
        },
      },
    },
  }));

  return {
    chatStyle,
    inputAreaStyle,
    textInput,
    submitButtonStyles,
    auxiliaryStyle,
    avatars,
    messageStyles,
  };
}